import { projectDetailSliceQuery } from '@/api/finance.js';

const state = {
  projectId: null,
  totalLatest: [],
  totalInvest: [],
  totalExit: [],
  detail: {},
  endDate: null,
  latest: [],
  invest: [],
  exit: []
};

const mutations = {
  setDetail: (state, res) => {
    let { data = {} } = res || {};
    let { latest = [], invest = [], exit = [], detail = {} } = data;
    state.detail = detail;
    state.totalLatest = latest;
    state.totalInvest = invest;
    state.totalExit = exit;
  },
  setProjectId: (state, projectId) => {
    state.projectId = projectId;
  },
  dateRangeFilter: (state, endDate) => {
    let { totalLatest, totalInvest, totalExit } = state;
    state.endDate = endDate;
    state.latest = totalLatest.filter(_ => !endDate || _.effectDate <= endDate);
    state.invest = totalInvest.filter(_ => !endDate || _.effectDate <= endDate);
    state.exit = totalExit.filter(_ => !endDate || _.effectDate <= endDate);
  }
};

const actions = {
  async fetchSlice({ commit, state }) {
    let { projectId } = state;
    let res = await projectDetailSliceQuery({ projectId });
    commit('setDetail', res);
    commit('dateRangeFilter', state.endDate);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
